import { API_AUTH } from "./common";

const NguonVonApi = {
  list: ({ ten, loaigiaodich }) =>
    API_AUTH.get(
      `nguon-von/danh-sach-nguon-von?ten=${ten}&loaigiaodich=${loaigiaodich}`,
      {}
    ),

  loaiGiaoDich: () => {
    return API_AUTH.get(`nguon-von/loai-giao-dich`, {});
  },

  chiTietNguonVon: (customerId) => {
    return API_AUTH.get(
      `nguon-von/chi-tiet-nguon-von?customerId=${customerId}`,
      {}
    );
  },

  lichSuNguonVon: (customerId, pageIndex, pageSize) => {
    return API_AUTH.get(
      `nguon-von/lich-su-nguon-von?customerId=${customerId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    );
  },

  addNguonVon: (
    ten,
    ngaysinh,
    diachi,
    dienthoai,
    cmnd,
    ngaycap,
    noicap,
    ngaygiaodich,
    nhanvien,
    sotiengop,
    ghichu
  ) =>
    API_AUTH.post(
      `nguon-von/them-moi-nguon-von?ten=${ten}&ngaysinh=${ngaysinh}&diachi=${diachi}&dienthoai=${dienthoai}&cmnd=${cmnd}&ngaycap=${ngaycap}&noicap=${noicap}&ngaygiaodich=${ngaygiaodich}&nhanvien=${nhanvien}&sotiengop=${sotiengop}&ghichu=${ghichu}`,
      {}
    ),

  editNguonVon: (
    customerId,
    ten,
    ngaysinh,
    diachi,
    dienthoai,
    cmnd,
    ngaycap,
    noicap,
    ngaygiaodich,
    nhanvien,
    sotiengop,
    ghichu
  ) =>
    API_AUTH.post(
      `nguon-von/sua-nguon-von?customerId=${customerId}&ten=${ten}&ngaysinh=${ngaysinh}&diachi=${diachi}&dienthoai=${dienthoai}&cmnd=${cmnd}&ngaycap=${ngaycap}&noicap=${noicap}&ngaygiaodich=${ngaygiaodich}&nhanvien=${nhanvien}&sotiengop=${sotiengop}&ghichu=${ghichu}`,
      {}
    ),

  editLichSuNguonVon: (thuchiId, customerId, type, thoigian, sotien, ghichu) =>
    API_AUTH.post(
      `nguon-von/luu-lich-su-nguon-von?thuchiId=${thuchiId}&customerId=${customerId}&type=${type}&thoigian=${thoigian}&sotien=${sotien}&ghichu=${ghichu}`,
      {}
    ),

  addGopVon: (customerId, ngaygiaodich, nhanviengiaodich, sotien, ghichu) =>
    API_AUTH.post(
      `nguon-von/luu-gop-von?customerId=${customerId}&ngaygiaodich=${ngaygiaodich}&nhanviengiaodich=${nhanviengiaodich}&sotien=${sotien}&ghichu=${ghichu}`,
      {}
    ),

  addRutVon: (customerId, ngaygiaodich, nhanviengiaodich, sotien, ghichu) =>
    API_AUTH.post(
      `nguon-von/luu-rut-von?customerId=${customerId}&ngaygiaodich=${ngaygiaodich}&nhanviengiaodich=${nhanviengiaodich}&sotien=${sotien}&ghichu=${ghichu}`,
      {}
    ),

  //   xoaPhieuThuChi: (thuChiId) => {
  //     return API_AUTH.post(
  //       `thu-chi-hop-dong/xoa-thu-chi-hop-dong?thuChiId=${thuChiId}`,
  //       {}
  //     );
  //   },
};

export default NguonVonApi;
